// Datos mock (hardcodeados) para el mockup del módulo "Oficina".
// No hay backend real: esta información sólo alimenta las vistas de demostración.

export const propertySummary = {
  total: 520,
  current: 467,
  overdue: 53,
  totalPending: 184500,
  collectedMonth: 735000,
  pendingToValidate: 12
}

export const delinquencySummary = {
  totalDelinquent: 53,
  totalDebt: 184500,
  percentage: 10.2,
  buckets: [
    { label: '1-30 días', count: 24, amount: 41500 },
    { label: '31-60 días', count: 15, amount: 52000 },
    { label: '61-90 días', count: 9, amount: 46000 },
    { label: '+90 días', count: 5, amount: 45000 }
  ]
}

export const recentPayments = [
  { date: '25/08/2026', house: '102', resident: 'Juan Pérez', concept: 'Mantenimiento mensual', amount: 1500, method: 'Transferencia', status: 'Pendiente' },
  { date: '24/08/2026', house: '245', resident: 'María López', concept: 'Mantenimiento mensual', amount: 1500, method: 'Tarjeta', status: 'Validado' },
  { date: '24/08/2026', house: '318', resident: 'Carlos García', concept: 'Cuota extraordinaria', amount: 3000, method: 'Efectivo', status: 'Validado' },
  { date: '23/08/2026', house: '077', resident: 'Ana Martínez', concept: 'Mantenimiento mensual', amount: 1500, method: 'Transferencia', status: 'Rechazado' },
  { date: '22/08/2026', house: '410', resident: 'Roberto Sánchez', concept: 'Mantenimiento mensual', amount: 1500, method: 'Tarjeta', status: 'Pendiente' },
  { date: '21/08/2026', house: '156', resident: 'Fernanda Torres', concept: 'Mantenimiento mensual', amount: 1500, method: 'Transferencia', status: 'Validado' }
]

export const feeConcepts = [
  { concept: 'Mantenimiento mensual', type: 'Ordinaria', amount: 1500, periodicity: 'Mensual', dueDate: 'Día 10', properties: 520, status: 'Activa' },
  { concept: 'Cuota extraordinaria — Remodelación de acceso', type: 'Extraordinaria', amount: 3000, periodicity: 'Única', dueDate: '30/09/2026', properties: 520, status: 'Activa' },
  { concept: 'Cuota Casa Club', type: 'Ordinaria', amount: 450, periodicity: 'Mensual', dueDate: 'Día 5', properties: 210, status: 'Activa' },
  { concept: 'Fondo de reserva anual', type: 'Otro', amount: 800, periodicity: 'Anual', dueDate: '15/01/2027', properties: 520, status: 'Inactiva' }
]

export const paymentsList = [
  { date: '25/08/2026', house: '102', resident: 'Juan Pérez', concept: 'Mantenimiento mensual', amount: 1500, method: 'Transferencia', voucher: 'comprobante_102.pdf', status: 'Pendiente' },
  { date: '24/08/2026', house: '245', resident: 'María López', concept: 'Mantenimiento mensual', amount: 1500, method: 'Tarjeta', voucher: 'comprobante_245.pdf', status: 'Validado' },
  { date: '24/08/2026', house: '318', resident: 'Carlos García', concept: 'Cuota extraordinaria', amount: 3000, method: 'Efectivo', voucher: 'comprobante_318.pdf', status: 'Validado' },
  { date: '23/08/2026', house: '077', resident: 'Ana Martínez', concept: 'Mantenimiento mensual', amount: 1500, method: 'Transferencia', voucher: 'comprobante_077.pdf', status: 'Rechazado' },
  { date: '22/08/2026', house: '410', resident: 'Roberto Sánchez', concept: 'Mantenimiento mensual', amount: 1500, method: 'Tarjeta', voucher: 'comprobante_410.pdf', status: 'Pendiente' },
  { date: '21/08/2026', house: '156', resident: 'Fernanda Torres', concept: 'Mantenimiento mensual', amount: 1500, method: 'Transferencia', voucher: 'comprobante_156.pdf', status: 'Validado' },
  { date: '20/08/2026', house: '203', resident: 'Luis Hernández', concept: 'Cuota Casa Club', amount: 450, method: 'Tarjeta', voucher: 'comprobante_203.pdf', status: 'Validado' },
  { date: '19/08/2026', house: '389', resident: 'Patricia Ramírez', concept: 'Mantenimiento mensual', amount: 1500, method: 'Efectivo', voucher: 'comprobante_389.pdf', status: 'Pendiente' }
]

export const delinquentHouses = [
  { house: '077', owner: 'Ana Martínez', totalDebt: 4500, pendingFees: 3, daysLate: 25, lastPayment: '15/06/2026', status: '1-30 días' },
  { house: '199', owner: 'Jorge Castillo', totalDebt: 6000, pendingFees: 4, daysLate: 48, lastPayment: '02/06/2026', status: '31-60 días' },
  { house: '256', owner: 'Sofía Delgado', totalDebt: 9000, pendingFees: 6, daysLate: 75, lastPayment: '10/04/2026', status: '61-90 días' },
  { house: '312', owner: 'Miguel Ángel Ruiz', totalDebt: 13500, pendingFees: 9, daysLate: 130, lastPayment: '05/01/2026', status: '+90 días' },
  { house: '430', owner: 'Daniela Guzmán', totalDebt: 3000, pendingFees: 2, daysLate: 18, lastPayment: '20/07/2026', status: '1-30 días' },
  { house: '511', owner: 'Ricardo Flores', totalDebt: 7500, pendingFees: 5, daysLate: 55, lastPayment: '28/05/2026', status: '31-60 días' }
]

export const officeUsers = [
  { username: 'jperez', name: 'Juan Pérez', email: 'juan@fraccionamiento.com', role: 'Administrador', lastAccess: '25/08/2026 09:12', status: 'Activo', permissions: ['invitations', 'residents', 'employees', 'areas', 'fees'] },
  { username: 'mlopez', name: 'María López', email: 'maria@fraccionamiento.com', role: 'Ejecutivo', lastAccess: '24/08/2026 18:40', status: 'Activo', permissions: ['invitations', 'residents'] },
  { username: 'cgarcia', name: 'Carlos García', email: 'carlos@fraccionamiento.com', role: 'Consulta', lastAccess: '20/08/2026 11:05', status: 'Inactivo', permissions: [] },
  { username: 'ftorres', name: 'Fernanda Torres', email: 'fernanda@fraccionamiento.com', role: 'Finanzas', lastAccess: '25/08/2026 08:02', status: 'Activo', permissions: ['fees'] }
]

export const officePermissions = [
  { value: 'invitations', label: 'Enviar invitaciones' },
  { value: 'residents', label: 'Gestionar residentes' },
  { value: 'employees', label: 'Gestionar empleados y accesos' },
  { value: 'areas', label: 'Gestionar áreas de oficina' },
  { value: 'fees', label: 'Gestionar cuotas y pagos' }
]

export const officeEmployees = [
  { id: 1, name: 'Miguel Hernández', position: 'Mantenimiento', area: 'Mantenimiento', days: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie'], startTime: '08:00', endTime: '17:00', status: 'Activo' },
  { id: 2, name: 'Laura Sánchez', position: 'Recepcionista', area: 'Recepción', days: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'], startTime: '09:00', endTime: '18:00', status: 'Activo' },
  { id: 3, name: 'Roberto Díaz', position: 'Jardinero', area: 'Mantenimiento', days: ['Lun', 'Mié', 'Vie'], startTime: '07:00', endTime: '15:00', status: 'Inactivo' }
]

export const officeEmployeeAccessLogs = [
  { id: 1, employeeId: 1, date: '31/08/2026', checkIn: '07:56', checkOut: '17:03', guardhouse: 'Caseta principal' },
  { id: 2, employeeId: 1, date: '28/08/2026', checkIn: '08:02', checkOut: '16:58', guardhouse: 'Caseta principal' },
  { id: 3, employeeId: 2, date: '31/08/2026', checkIn: '08:51', checkOut: '18:06', guardhouse: 'Caseta principal' },
  { id: 4, employeeId: 2, date: '30/08/2026', checkIn: '09:03', checkOut: '17:59', guardhouse: 'Acceso de servicio' },
  { id: 5, employeeId: 3, date: '29/08/2026', checkIn: '06:54', checkOut: '15:08', guardhouse: 'Acceso de servicio' }
]

export const officeAreas = [
  { id: 1, name: 'Recepción', manager: 'María López', invitationType: 'Visitas generales', active: true },
  { id: 2, name: 'Administración', manager: 'Juan Pérez', invitationType: 'Proveedores y trámites', active: true },
  { id: 3, name: 'Mantenimiento', manager: 'Miguel Hernández', invitationType: 'Personal de servicio', active: true }
]

export const officeInvitations = [
  { id: 1, guest: 'Servicios Hidráulicos MX', type: 'Proveedor', area: 'Mantenimiento', visitDate: '30/08/2026', startTime: '10:00', endTime: '14:00', status: 'Activa', createdBy: 'Juan Pérez' },
  { id: 2, guest: 'Ana Rivera', type: 'Visita', area: 'Recepción', visitDate: '31/08/2026', startTime: '12:00', endTime: '13:00', status: 'Activa', createdBy: 'María López' }
]

export const officeRoles = [
  { value: 'Administrador', color: 'green', description: 'Acceso completo.' },
  { value: 'Ejecutivo', color: 'blue', description: 'Acceso a funciones administrativas generales.' },
  { value: 'Finanzas', color: 'orange', description: 'Acceso a cuotas, pagos y morosidad.' },
  { value: 'Consulta', color: 'grey', description: 'Solo lectura.' }
]

export const administrativeAlerts = [
  { type: 'warning', icon: 'mdi-cash-clock', text: '12 pagos están pendientes de validar.' },
  { type: 'info', icon: 'mdi-calendar-alert', text: 'La cuota de mantenimiento vence en 5 días.' },
  { type: 'error', icon: 'mdi-trending-up', text: 'La morosidad aumentó 2.3% respecto al mes anterior.' },
  { type: 'warning', icon: 'mdi-home-alert', text: '5 propiedades acumulan adeudos de más de 90 días.' }
]

export function statusColor (status) {
  switch (status) {
    case 'Validado':
    case 'Activa':
    case 'Activo':
      return 'green'
    case 'Pendiente':
      return 'orange'
    case 'Rechazado':
    case 'Inactiva':
    case 'Inactivo':
      return 'red'
    case '1-30 días':
      return 'orange'
    case '31-60 días':
      return 'deep-orange'
    case '61-90 días':
      return 'red'
    case '+90 días':
      return 'red darken-3'
    default:
      return 'grey'
  }
}

export function roleColor (role) {
  const found = officeRoles.find(r => r.value === role)
  return found ? found.color : 'grey'
}
